'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../../ui/button';
import { useState } from 'react';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { FaCircleQuestion } from 'react-icons/fa6';

export function ProductAskForProduct({
  product,
  className,
}: {
  product: ProductDetailData;
  className?: string;
}) {
  const open = useDialogStore(state => state.open);
  const { t } = useTranslations();
  const [loading, setLoading] = useState(false);
  const handleOpen = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const { ASK_FOR_PRODUCT_DIALOG_ID, ProductAskDialog } =
        await import('@eliadmin/core/src/components/product/detail/product-ask-dialog');
      open({ id: ASK_FOR_PRODUCT_DIALOG_ID, content: <ProductAskDialog title={product.name} /> });
    } catch {
      toast({ title: t('text660'), variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className={cn(className, 'ea-product-detail-actions__ask-for-product-button-wrapper')}>
      <Button
        type="button"
        onClick={handleOpen}
        disabled={loading}
        isLoading={loading}
        aria-label="Opýtať sa na produkt"
        aria-busy={loading}
        className={cn('px-0 !no-underline', 'ea-product-detail-actions__ask-for-product-button')}
        variant="link"
      >
        <FaCircleQuestion
          className={cn(
            'h-5 w-5 text-primary',
            'ea-product-detail-actions__ask-for-product-button-icon',
          )}
        />
        <p className="whitespace-nowrap text-sm font-normal text-foreground !no-underline">
          Opýtať sa na produkt
        </p>
      </Button>
    </div>
  );
}
